import React from 'react'
import { Box, Typography } from '@mui/material'

import ClientHeader from '../../../components/ClientHeader/ClientHeader'
import DetailsSummarySection from '../../../components/details/summary/DetailsSummarySection'
import FormHeaderDetailActions from '../../../components/action_button/FormHeaderDetailActions'
import { POS_TASK_HEADER_CONFIG } from '../shared/posDetailsConstants'

export default function PosDetailsDesktop({
  headerData,
  summaryFields,
  scopeFields,
  assignmentFields,
  assignmentEmptyContent,
  extraTitle,
  extraFields,
  extraContent,
  activity,
  showActions,
  suspending,
  onSuspend,
  onClone
}) {
  return (
    <div className="container-fluid px-0">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
          mt: 3,
          mb: 3,
          ml: '5px'
        }}
      >
        <Typography sx={{ fontSize: 18, m: 0, lineHeight: 1.3 }}>
          Detalles de tarea en punto de venta:
        </Typography>

        {showActions && (
          <FormHeaderDetailActions
            secondaryLabel="Suspender tarea"
            onSecondary={onSuspend}
            showSecondary={!activity.suspended}
            primaryLabel="Crear copia de tarea"
            onPrimary={onClone}
            disabled={suspending}
            className="pos-details-actions"
          />
        )}
      </Box>

      <ClientHeader data={headerData} config={POS_TASK_HEADER_CONFIG} cardSx={{ p: 2, mb: 2 }} />

      <DetailsSummarySection
        summaryFields={summaryFields}
        scopeFields={scopeFields}
        assignmentFields={assignmentFields}
        assignmentEmptyContent={assignmentEmptyContent}
        extraFields={extraFields}
        extraContent={extraContent}
        summaryTitle="DETALLES DE LA TAREA"
        scopeTitle="CLIENTES Y ATRIBUTOS"
        assignmentTitle="TAREA ASIGNADA A"
        extraTitle={extraTitle}
        secondarySectionsType="title"
        summaryOpenLabel="Abrir detalles de la tarea"
        summaryCloseLabel="Cerrar detalles de la tarea"
        scopeOpenLabel="Abrir clientes y atributos"
        scopeCloseLabel="Cerrar clientes y atributos"
        assignmentOpenLabel="Abrir tarea asignada a"
        assignmentCloseLabel="Cerrar tarea asignada a"
        extraOpenLabel="Abrir datos específicos de la tarea"
        extraCloseLabel="Cerrar datos específicos de la tarea"
      />
    </div>
  )
}
